import { render, staticRenderFns } from "./SrFooter.vue?vue&type=template&id=1264e845"
import script from "./SrFooter.vue?vue&type=script&lang=js"
export * from "./SrFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports